import styled, { css, keyframes } from 'styled-components';

const spinAnimation = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;

export const Container = styled.div<{ $userThemeEnabled?: boolean }>`
  height: 100vh;
  max-height: 100%;
  width: 100vw;
  max-width: 100%;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;

  ${({ $userThemeEnabled }) =>
    $userThemeEnabled &&
    css`
      @media (prefers-color-scheme: dark) {
        background-color: rgb(30, 30, 30);
      }

      @media (forced-colors: active) {
        background-color: #000000;
      }
    `}
`;

export const Spinner = styled.div<{ $userThemeEnabled?: boolean }>`
  border: 3px solid rgb(219, 219, 219);
  border-top: 3px solid transparent;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  animation: ${spinAnimation} 2s linear infinite;

  ${({ $userThemeEnabled }) =>
    $userThemeEnabled &&
    css`
      @media (prefers-color-scheme: dark) {
        border-color: rgb(90, 90, 90);
        border-top-color: rgb(200, 200, 200);
      }

      @media (forced-colors: active) {
        border-color: #ffffff;
        border-top-color: transparent;
      }
    `}
`;
